'use es6';

import { TEMPLATE_BUFFER_FETCH, TEMPLATE_BUFFER_SAVE, TEMPLATE_BUFFER_SAVE_BY_PATH, TEMPLATE_SAVE_BY_PATH, TEMPLATE_BUFFER_PUBLISH, CUSTOM_WIDGET_SAVE_BY_PATH, CUSTOM_WIDGET_BUFFER_SAVE, CUSTOM_WIDGET_BUFFER_SAVE_BY_PATH, CUSTOM_WIDGET_BUFFER_VALIDATE, CUSTOM_WIDGET_BUFFER_PUBLISH, CUSTOM_WIDGET_BUFFER_FORCE_UPGRADE, LAYOUT_PUBLISH, LAYOUT_BUFFER_SAVE, RAW_ASSET_BUFFER_SAVE, RAW_ASSET_BUFFER_SAVE_BY_PATH, RAW_ASSET_PUBLISH, RAW_ASSET_SAVE_BY_PATH, RAW_ASSET_BUFFER_JSON_LINT, VALIDATE_TEMPLATE, VALIDATE_LAYOUT, FINDER_FILE_DUPLICATE } from 'DesignData/actions/ActionTypes';
import { getFieldLabels, createCodePaneSessionId } from 'DesignData/helpers/customWidgetFieldsHelper';
import SeamlessImmutable from 'seamless-immutable';
import { CSS as CUSTOM_WIDGET_EDITOR_PANE_TYPE_CSS, JS } from 'DesignData/enums/CustomWidgetEditorPaneTypes'; // IDE Errors //

import * as editorErrorHelper from 'DesignData/helpers/editorErrorHelper';
import * as editorErrorsActions from 'DesignData/actions/EditorErrors';
import * as customWidgetBuffersSelector from 'DesignData/selectors/customWidgetBuffers';
import * as customWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import * as hublValidatorSelectors from 'DesignData/selectors/hublValidator';
import * as editorErrorsSelectors from 'DesignData/selectors/editorErrors';
import { createMinificationError } from 'DesignData/helpers/editorErrorHelper';
import { WARNING } from 'DesignData/enums/EditorErrorTypes';
import { SET_CURSOR_IN_IDE_CODE_MIRROR } from 'DesignData/enums/FlashKeys';
const getCustomWidgetBuffer = customWidgetBuffersSelector.makeGetCustomWidgetBuffer();
const getCustomWidgetBufferFields = customWidgetBuffersSelector.makeGetCustomWidgetBufferFields();

function handleValidationErrors(dispatch, assetId, result, data, extraErrors = [], options = {}) {
  const errors = editorErrorHelper.getErrors(result.error, data, options).concat(extraErrors);

  if (errors.length) {
    dispatch(editorErrorsActions.setErrors(assetId, errors));
  }
}

function handleHublValidatorErrors(dispatch, assetId, sessionId, errors) {
  const editorErrors = editorErrorHelper.getErrorsFromHublValidation(errors, sessionId);

  if (editorErrors.length) {
    dispatch(editorErrorsActions.setHublErrors(assetId, sessionId, editorErrors));
  } else {
    dispatch(editorErrorsActions.clearHublErrors(assetId, sessionId));
  }
}

function handleLayoutHublValidationErrors(dispatch, layoutId, headErrors, footerErrors, widgetErrors, existingErrors) {
  const editorErrors = editorErrorHelper.getErrorsFromLayoutHublValidation(headErrors, footerErrors, widgetErrors, dispatch, layoutId).concat(existingErrors);

  if (editorErrors.length) {
    dispatch(editorErrorsActions.setErrors(layoutId, editorErrors));
  } else {
    dispatch(editorErrorsActions.clearErrors(layoutId));
  }
}

function onCodeEditorErrorClick(sessionId, lineNumber) {
  const column = 0;
  const endColumn = 0;
  return flash => {
    flash(SET_CURSOR_IN_IDE_CODE_MIRROR, {
      sessionId,
      lineNumber: lineNumber - 1,
      endLineNumber: lineNumber - 1,
      column,
      endColumn
    });
  };
}

export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  const state = getState();

  switch (result.type) {
    case TEMPLATE_BUFFER_FETCH:
    case TEMPLATE_BUFFER_SAVE:
    case TEMPLATE_BUFFER_SAVE_BY_PATH:
    case TEMPLATE_SAVE_BY_PATH:
      {
        const assetId = result.templateId;
        const existingErrors = editorErrorsSelectors.getAllAnnotationsForBufferSave(state, {
          assetId
        });

        if (result.error) {
          handleValidationErrors(dispatch, assetId, result, null, existingErrors);
        } else if (result.template && !existingErrors.length) {
          dispatch(editorErrorsActions.clearErrors(assetId));
        }

        if (result.template && result.template.minificationError) {
          const err = {
            errorType: 'MINIFICATION_ERROR',
            errorTokens: {
              helpMessageLink: 'https://knowledge.hubspot.com/cos-general/customize-design-manager-settings',
              rawMessage: result.template.minificationError,
              openOutputPane: `code/${assetId}`,
              minificationErrorLineNo: result.template.minificationErrorLineNo,
              onLineClick: onCodeEditorErrorClick(assetId, result.template.minificationErrorLineNo)
            },
            sessionId: result.template.templateId
          };
          dispatch(editorErrorsActions.setErrors(assetId, [createMinificationError(err, WARNING)]));
        }

        break;
      }

    case TEMPLATE_BUFFER_PUBLISH:
      {
        if (result.error) {
          handleValidationErrors(dispatch, result.templateId, result);
        } else if (result.template) {
          dispatch(editorErrorsActions.clearErrors(result.templateId));
        }

        break;
      }

    case CUSTOM_WIDGET_BUFFER_SAVE:
    case CUSTOM_WIDGET_BUFFER_SAVE_BY_PATH:
    case CUSTOM_WIDGET_SAVE_BY_PATH:
    case CUSTOM_WIDGET_BUFFER_VALIDATE:
    case CUSTOM_WIDGET_BUFFER_PUBLISH:
    case CUSTOM_WIDGET_BUFFER_FORCE_UPGRADE:
      {
        const {
          customWidgetId
        } = result;
        const {
          customWidget = null
        } = action;
        const {
          css,
          js,
          label,
          warnings: customWidgetWarnings
        } = customWidget || getCustomWidgetBuffer(state, {
          customWidgetId
        });
        const cssSessionId = createCodePaneSessionId(customWidgetId, CUSTOM_WIDGET_EDITOR_PANE_TYPE_CSS);
        const jsSessionId = createCodePaneSessionId(customWidgetId, JS);
        const cssWarnings = editorErrorHelper.getHublInCssOrJsWarnings(css, cssSessionId);
        const jsWarnings = editorErrorHelper.getHublInCssOrJsWarnings(js, jsSessionId);
        const fields = getCustomWidgetBufferFields(state, {
          customWidgetId
        });
        const fieldLabels = getFieldLabels(fields);

        const setSelectedField = fieldId => dispatch(customWidgetEditorOptionsActions.setSelectedField(customWidgetId, {
          id: fieldId
        }));

        const data = {
          moduleLabel: label,
          fieldLabels,
          setSelectedField
        };
        const revisedFieldWarnings = editorErrorHelper.getCustomWidgetWarnings(customWidgetWarnings || result.warnings, data);
        const warnings = cssWarnings.concat(jsWarnings, revisedFieldWarnings);

        if (result.error || warnings.length) {
          const options = {// omitSourceErrors: true,
          };
          handleValidationErrors(dispatch, customWidgetId, result, data, warnings, options);
        } else if (result.customWidget) {
          dispatch(editorErrorsActions.clearErrors(customWidgetId));
        }

        break;
      }

    case RAW_ASSET_BUFFER_JSON_LINT:
      {
        const {
          rawAssetId: assetId,
          error
        } = result;

        if (error) {
          dispatch(editorErrorsActions.setJsErrors(assetId, error.sessionId, [error]));
        } else {
          dispatch(editorErrorsActions.clearJsErrors(assetId));
        }

        break;
      }

    case RAW_ASSET_PUBLISH:
    case RAW_ASSET_SAVE_BY_PATH:
    case RAW_ASSET_BUFFER_SAVE:
    case RAW_ASSET_BUFFER_SAVE_BY_PATH:
      {
        const {
          rawAssetId: assetId
        } = result;

        if (result.error) {
          handleValidationErrors(dispatch, assetId, result);
        } else {
          dispatch(editorErrorsActions.clearErrors(assetId));
        }

        break;
      }

    case LAYOUT_BUFFER_SAVE:
      {
        const assetId = result.layoutId;

        if (result.error) {
          handleValidationErrors(dispatch, assetId, result);
        } else {
          dispatch(editorErrorsActions.clearErrors(assetId));
        }

        break;
      }

    case FINDER_FILE_DUPLICATE:
    case LAYOUT_PUBLISH:
      {
        if (result.error) {
          const assetId = result.layoutId || result.fileId;
          handleValidationErrors(dispatch, assetId, result);
        } else {
          const errors = editorErrorsSelectors.getErrorsById(state, {
            assetId: result.layoutId
          }) || [];
          const errorsToKeepOnSave = errors.filter(_error => _error.keepOnSave);

          if (errorsToKeepOnSave.length) {
            dispatch(editorErrorsActions.setErrors(result.layoutId, errorsToKeepOnSave));
          } else {
            dispatch(editorErrorsActions.clearErrors(result.layoutId));
          }
        }

        break;
      }

    case VALIDATE_TEMPLATE:
      {
        const {
          assetId,
          sessionId,
          renderingErrors,
          error
        } = result;
        if (!(renderingErrors || error)) break;

        if (assetId && renderingErrors) {
          handleHublValidatorErrors(dispatch, assetId, sessionId, renderingErrors);
        } else {
          dispatch(editorErrorsActions.clearErrors(assetId));
        }

        break;
      }

    case VALIDATE_LAYOUT:
      {
        const {
          layoutId,
          isHead,
          isFooter,
          renderingErrors,
          error,
          widgetId,
          widgetField
        } = result;
        if (!(renderingErrors || error)) break;

        if (layoutId && renderingErrors) {
          const headErrors = isHead ? renderingErrors : hublValidatorSelectors.getLayoutHeadErrors(state, {
            layoutId
          });
          const footerErrors = isFooter ? renderingErrors : hublValidatorSelectors.getLayoutFooterErrors(state, {
            layoutId
          });
          /* Add support for errors in nested fields */

          const widgetFieldKey = Array.isArray(widgetField) ? widgetField.join('-') : widgetField;
          const widgetErrors = SeamlessImmutable(hublValidatorSelectors.getLayoutWidgetsErrorsByIdWithLabels(state, {
            layoutId
          }));
          const updatedWidgetErrors = widgetId ? widgetErrors.setIn([widgetId, widgetFieldKey], renderingErrors) : widgetErrors;
          const existingErrors = editorErrorsSelectors.getAllAnnotationsForBufferSave(state, {
            assetId: layoutId
          });
          handleLayoutHublValidationErrors(dispatch, layoutId, headErrors, footerErrors, updatedWidgetErrors, existingErrors);
        } else {
          dispatch(editorErrorsActions.clearErrors(layoutId));
        }

        break;
      }

    default:
      break;
  }

  return result;
});